import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-end" }
const _hoisted_18 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            type: "text",
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Code place, marchand, référence, désignation…",
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Code place "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Marchand "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Réf. contrat "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Désignation "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Quantité "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Prix unit. "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant ligne "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Groupe de taxe "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " État "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(row?.contrat?.codePlace), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(row?.contrat?.nomMarchand), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(row?.contrat?.reference), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(row?.element?.designation), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(row?.quantite), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(row?.prix), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(row?.montant), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(row?.groupeTaxe?.libelle), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.libelleEtat(row?.etatElement)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.format_date(row?.createdAt)), 1),
                _createElementVNode("td", _hoisted_17, [
                  (row?.contrat?.id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/view-contrat/${row.contrat.id}`,
                        class: "btn btn-sm btn-outline-primary"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Voir contrat ")
                        ])),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}